import React from 'react';
import { styled } from '@mui/material/styles';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const StyledIcon = styled(ErrorOutlineIcon)`
  color: ${props => props.color || '#f44336'};
`;

const ExclamationIcon = props => {
  return <StyledIcon {...props} />;
};

export default ExclamationIcon;
